import React from 'react';
import { createRoot } from 'react-dom/client';
import { get } from 'lodash';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { MDTApp } from 'mdt-core-components/src/actions/bootAction.js';
import { MDTApi } from 'mdt-core-components/src/services/mdtapi.js';
import { sendEventTrackingData } from 'mdt-core-components/src/helpers/commonUtils.js';
import { BrowserRouter as Router } from 'react-router-dom';
import { Spinner } from 'mdt-core-components';
import { startListener } from 'mdt-core-components/src/listeners/history.js';
import configureStore from './configureStore.js';
import { subscribePermissionGuard } from './options.js';
import App from './components/App.js';
import './index.css';

const history = createBrowserHistory();
const store = configureStore(history);

// Subscribe to store changes to re-check route permissions once bootstrap completes.
// onBeforeChange fires during store creation (before permissions are loaded), so it
// must be permissive during bootstrap. This subscriber catches the moment
// HAS_RESOURCE_RIGHTS becomes true and redirects unauthorized users.
subscribePermissionGuard(store);

const root = createRoot(document.getElementById('root'));

// TODO: Look for a central place to put this 20231017:Alevale
const settings = {
    buid: 'MDT',
    appid: 'CENT',
    basesiteid: 'mdtb2bsite',
};

MDTApp.registerSettings(settings);
MDTApp.registerStore(store);
MDTApi.registerStore(store);

// Start the history listener
startListener(history, store);
const render = (App) =>
    new Promise(function (resolveStore) {
        // TODO: Refactor the init bootstrap to have the minimal amount of API's necessary
        //  (until this function hasn't finished there's nothing rendered in the page, so if an API
        //  call takes 20s we have 20s of an empty page) which is far from ideal 20240801:Alevale
        store.dispatch(MDTApp.initBootstrap(resolveStore));
        // NOTE: While we are waiting at least show a spinner 20240801:Alevale
        root.render(
            <Spinner
                {...{
                    showLoading: true,
                    browserSupportsAnimations: true,
                }}
            />
        );
    })
        .then(function () {
            const { meDetails } = store.getState();
            const isUserInternal = get(meDetails, 'isInternal', '');
            const customerSelected = localStorage.getItem('CustomerSelected');
            if (
                isUserInternal.toLocaleLowerCase() === 'false' ||
                (isUserInternal.toLocaleLowerCase() !== 'false' && customerSelected === 'true')
            ) {
                root.render(
                    <Provider store={store}>
                        <Router>
                            <App />
                        </Router>
                    </Provider>
                );
            } else {
                const customerId = meDetails.defaultCustomer && meDetails.defaultCustomer.id;
                const url = window.MDTSetting.links['portal-select-customer'];

                const dateTime = new Date().toJSON();
                const userType = isUserInternal === 'True' ? 'Internal' : 'External';
                const eventParamObj = {
                    eventCategory: 'accManagement',
                    eventAction: 'login',
                    eventLabel: `Login_${userType} : ${dateTime}`,
                    processLabels: false,
                };
                sendEventTrackingData(eventParamObj);

                MDTApp.goto(url, {
                    refererAppId: window.MDTSetting.appid,
                    refererAppUrl: window.location.href,
                    customerId,
                });
            }
        })
        .catch((error) => {
            console.log('Error while bootstrapping', error);
            console.error(error);
        });

render(App);
